import * as React from "react";

import { cn } from "./utils";

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
	return (
		<input
			type={type}
			data-slot="input"
			className={cn(
				"file:text-foreground placeholder:text-placeholder selection:bg-accent selection:text-foreground border-input flex h-11 w-full min-w-0 rounded-md border bg-input-background px-3 py-2 text-base font-semibold transition-[border-color,box-shadow,background-color] outline-none hover:bg-input-hover file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-muted disabled:text-muted-foreground disabled:opacity-100 md:text-sm",
				"focus-visible:border-ring focus-visible:bg-field-focus focus-visible:ring-ring/25 focus-visible:ring-[3px]",
				"aria-invalid:border-destructive aria-invalid:ring-danger-tint",
				className,
			)}
			{...props}
		/>
	);
}

export { Input };
